import { render, staticRenderFns } from "./ResendVerificationEmailModal.vue?vue&type=template&id=34fd2f55&scoped=true"
import script from "./ResendVerificationEmailModal.vue?vue&type=script&lang=js"
export * from "./ResendVerificationEmailModal.vue?vue&type=script&lang=js"
import style0 from "./ResendVerificationEmailModal.vue?vue&type=style&index=0&id=34fd2f55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fd2f55",
  null
  
)

export default component.exports